function MartimeCareers() {
  return (
    <>
      <div className="row g-5">
        <div className="col-12">
          <div className="service-title text-green-38B652 font-700 mb-3">
            CAREER GUIDANCE IN THE MARITIME INDUSTRY
          </div>

          <div className="service-box mb-5 mb-sm-4">
            The Maritime Industry offers careers that have Nationally and
            Internationally recognised tertiary qualifications, job
            satisfaction, a high level of responsibility, good advancement
            prospects and a wide variety of careers both at sea and ashore.
          </div>

          <div className="row g-3 g-sm-4 g-md-5">
            <div className="col-12">
              <p className="font-17 text-primary-color mb-3">
                SA Maritime Sector Skills Development Model and Careers
                Opportunities in the Maritime Sector{" "}
              </p>
              <ul className="list-order mb-3">
                <li>
                  List of Maritime Specific and Maritime Related education and
                  training offered by SA providers and institutions. Click here
                  to view the List
                </li>
                <li>
                  The South African Maritime Safety Authority (SAMSA),an Agency
                  of Government, is pursuing a growth strategy that prioritises
                  the development and retention of quality critical and scarce
                  skills within the maritime sector.{" "}
                </li>
                <li>
                  SAMSA, the South African Navy and the maritime industry
                  including the private sector, are most important partners for
                  skills development in the maritime sector.
                </li>
              </ul>
              {/* <div className="font-20 font-600 text-primary-color mb-3">
                <a
                  className="text-decoration-none font-20 font-600 text-green-38B652"
                  target="_blank"
                  href="https://www.samsa.org.za/sites/samsa.org.za/files/SAMSA_Executive_Summary_18-09-2011_0.pdf"
                >
                  More on SAMSA Executive Summary
                </a>
                ​
              </div> */}

              <p className="font-17 text-primary-color mb-1">
                <b>Careers On board a Ship​</b>
              </p>

              <ul className="list-order mb-3">
                <li>Captain</li>
                <li>Navigating officers</li>
                <li>Engineering officers</li>
                <li>Catering staff</li>
              </ul>

              <p className="font-17 text-primary-color mb-1">
                <b>School Requirements​</b>
              </p>

              <ul className="list-order mb-3">
                <li>
                  Grade 12 / N3 (Mathematics​ and Science compulsory - Std or
                  Higher grade level - 60% pass rate)
                </li>
                <li>
                  Grade 10 ( N1, N2, N3 with Mathematics and Science - Std or
                  Higher grade level - 60% pass rate)
                </li>
                <li>
                  Scholars with Grade 12 certificate without Mathematics and
                  science can do a six-month bridging course with any
                  institution offering Maritime Studies.
                </li>
              </ul>

              <p className="font-17 text-primary-color mb-1">
                <b>Further Education​</b>
              </p>

              <p className="font-17 text-primary-color mb-3">
                Aspiring cadets can enroll at either Durban University of
                Technology or Cape Peninsula University of Technology in
                Maritime Studies or Mechanical Engineering.
              </p>
              <p className="font-17 text-primary-color mb-3">
                They must complete S1 and S2 (Certificate in Maritime Studies)
                at either Durban University of Technology or Cape Peninsula
                University of Technology (once this course is complete, the
                student will have the choice of becoming a Navigating or
                Engineering Officer).
              </p>
              <p className="font-17 text-primary-color mb-3">
                After completion of S1 and S2, the student will have to join a
                shipping company to complete a 12-month sea service training
                period (e.g. shipping companies: Unicorn, Safmarine, Mearsk).
              </p>
              <p className="font-17 text-primary-color mb-3">
                Pass SAMSA oral exam to qualify either as a Deck or an Engineer
                Officer.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Complete S3 (National Diploma in Maritime Studies) at either
                Durban University or Cape Peninsula University of Technology.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Complete further 12-month sea service.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Pass SAMSA oral exam to qualify either as Chief Navigating
                Officer or Second Engineering Officer.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Complete S4 (Higher Diploma in Maritime Studies) at either
                Durban University or Cape Peninsula University of Technology.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Complete further 12-month sea service.
              </p>
              <p className="font-17 text-primary-color mb-3">
                Pass SAMSA oral exams to qualify either as Master or Chief
                Engineer
              </p>

              <div className="card mb-3">
                <div className="card-header font-18 font-700">
                  ​​Contact Details
                </div>
                <div className="card-body">
                  <div className="row g-4">
                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          ​​South African Maritime Safety Authority (SAMSA)
                          <br /> John Phiri(Skills Development Manager)​​​
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> 012 - 366 2648
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Email:</span>{" "}
                        <a href="mailto:jphiri@samsa.org.za">
                          jphiri@samsa.org.za
                        </a>
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          ​Cape Peninsula University of Technology (Faculty
                          Office)​
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> 021 - 460 32 55
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Email:</span>{" "}
                        <a href="mailto:thomasjc@cput.ac.za">
                          thomasjc@cput.ac.za
                        </a>
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          ​Granger Bay Campus
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> 021 - 440 5752
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Email:</span>{" "}
                        <a href="mailto:maritime@cput.ac.za">
                          maritime@cput.ac.za
                        </a>
                      </p>

                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> 021 - 440 5755
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Email:</span>{" "}
                        <a href="mailto:snyderse@cput.ac.za">
                          snyderse@cput.ac.za
                        </a>
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          Durban University of Technology
                          <br />
                          Department of Maritime Studies
                          <br />
                          The secretary​​​
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> 031 - 373 2144
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Email:</span>{" "}
                        <a href="mailto:arshnar@dut.ac.za">arshnar@dut.ac.za</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="service-title text-green-38B652 font-700 mb-3">
            CAREERS IN THE MARITIME INDUSTRY{" "}
          </div>

          <div className="service-box mb-5 mb-sm-4">
            The Maritime industry is associated with activities on all vessels
            used at sea and associated land-based services. Routes include
            oceans, coasts, seas, lakes, rivers and channels.
          </div>

          <div className="row g-3 g-sm-4 g-md-5">
            <div className="col-12">
              <p className="font-17 text-primary-color mb-3">
                The Maritime field offers a wide choice of career opportunities,
                many of which are international by nature.​
              </p>
              <p className="font-17 text-primary-color mb-3">
                <b>
                  The following is an indication of maritime careers but not
                  limited to:
                </b>
              </p>

              <ul className="list-number mb-3">
                <li>
                  <b>Marine and Ship Engineers -</b> involved with the
                  maintenance of the engine of a ship; responsible for all
                  engineering related needs of a ship. The Cape Peninsula
                  University of Technology and The Durban Institute of
                  Technology offer all required marine engineering subjects at a
                  tertiary level.
                </li>
                <li>
                  <b>Crewmember -</b> career can lead from a deck officer to
                  Captain.
                </li>
                <li>
                  <b>Deck officers -</b> required to navigate the ship safely
                  and efficiently.
                </li>
                <li>
                  <b>Maritime Law -</b> Maritime and fisheries lawyers are
                  concerned with the branch of law that governs international
                  maritime zones and maritime resources. The international law
                  of the sea and the network of conventions that governs
                  navigation, fishing, seabed mining, naval warfare and marine
                  pollution are within the sphere of interest of maritime
                  lawyers.
                </li>
                <li>
                  <b>Tug Masters -</b> Captains of tugs are responsible for
                  ships towing other vessels/barges when they are in trouble at
                  sea. They also give guidance to salvage (rescue) work.
                </li>
                <li>
                  <b>Marine Pilots -</b> guide ships when entering the
                  harbour/port, as the Master of the ship may not be well versed
                  with the geography of the port.
                </li>
                <li>
                  <b>Harbour Masters -</b> responsible for the overall control
                  of the Port - all activities including lighthouses. Vessel
                  trafficking systems, etc.
                </li>
                <li>
                  <b>Ship surveyors -</b> conduct inspections and surveys of
                  vessels; checking safety standards and condition of equipment.
                  They carry out these surveys for government, e.g. SAMSA, DoT
                  Agency, for classification societies, cargo owners or
                  underwriters (insurance companies).
                </li>
                <li>
                  <b>Maritime Environmentalist (Sea Pollution) -</b> are
                  involved in Management of the environment. Marine biologist
                  and oceanographers look at the prevention of oil spills from
                  ships, check for engine leaks, and how it can be prevented.
                  They endeavour to combat pollution, clean-ups and decide what
                  dispersants could be used and which species are highly
                  vulnerable. They also do risk assessments especially for blast
                  water management in addition they could also do testing and
                  approval of treatment systems and ensure the availability of
                  reception facilities.
                </li>
              </ul>

              <p className="font-17 text-primary-color mb-3">
                ​Various learnerships through the Transport SETA (TETA) are
                available and academic studies through various ce​ntres of
                development are offered (refer to institutions of higher
                learning).
              </p>

              <div className="card mb-4">
                <div className="card-header font-18 font-700">
                  COLLEGES / SCHOOLS FOR MARITIME STUDIES
                </div>
                <div className="card-body">
                  <div className="row g-4">
                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">​​​​New Forest</span>
                      </p>
                      <p class="font-17 text-primary-color">P O Box 53194</p>
                      <p class="font-17 text-primary-color">
                        Yellow-wood Park, 4001
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> (031) 462 6206
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Fax:</span> (031) 469 1816
                      </p>
                      <p class="font-17 text-primary-color">
                        Maritime Studies A: Grades 10 - 12
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          Simon's Town School
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">P O Box 38</p>
                      <p class="font-17 text-primary-color">
                        Simon's Town, 7995
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> (021) 786 1056
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Fax:</span> (021) 786 1065
                      </p>
                      <p class="font-17 text-primary-color">
                        Maritime Studies A & B: Grades 10 – 12, Boarding
                        facilities available for learners
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          ​​​​Sithengile High School
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">P O Box 419</p>
                      <p class="font-17 text-primary-color">
                        Clernaville, 3602
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> (031) 711 3673
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Fax:</span> (031) 707 5166
                      </p>
                      <p class="font-17 text-primary-color">
                        Maritime Studies A: Grades 10 - 12
                      </p>
                    </div>

                    <div class="col-md-6 col-sm-6">
                      <p class="font-16 text-primary-color mb-1">
                        <span className="font-16 font-600">
                          Tsiand Technical High School
                        </span>
                      </p>
                      <p class="font-17 text-primary-color">
                        Private Bag x8533
                      </p>
                      <p class="font-17 text-primary-color">Esikhaweni, 3887</p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Tel:</span> (035) 796 1040/70
                      </p>
                      <p class="font-17 text-primary-color">
                        <span className="font-500">Fax:</span> (035) 796 4062
                      </p>
                      <p class="font-17 text-primary-color">
                        Maritime Studies A: Grades 10 - 12
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <p className="font-17 text-primary-color mb-1">
                <b>WEBSITE LINKS</b>
              </p>
              <div className="row g-1">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-md-5 font-17 text-primary-color">
                      Department of Transport (DoT)
                    </div>
                    <div className="col-md-7">
                      <a
                        className="text-decoration-none text-green-38B652"
                        target="_blank"
                        href="http://www.transport.gov.za/"
                      >
                        www.transport.gov.za
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-md-5 font-17 text-primary-color">
                      Transport Education and Training Authority
                    </div>
                    <div className="col-md-7">
                      <a
                        className="text-decoration-none text-green-38B652"
                        target="_blank"
                        href="http://www.teta.org.za"
                      >
                        www.teta.org.za
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-md-5 font-17 text-primary-color">
                      National Ports Authority
                    </div>
                    <div className="col-md-7">
                      <a
                        className="text-decoration-none text-green-38B652"
                        target="_blank"
                        href="http://www.transport.gov.za/"
                      >www.transnet.net</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MartimeCareers;
